import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { t } from 'bv-i18n';
import { EventIcons } from 'sportsbook-components';

const EventDetailView = ({
  eventHref,
  opponentADescription,
  opponentBDescription,
  scoresA,
  scoresB,
  opponentAActive,
  opponentBActive,
  badges,
}) => (
  <Link to={eventHref} className="inply-coupon-competition-column">
    <span className="inply-coupon-streaming-icon invisible" />

    { /* Team A ---------------------------------------------------- */ }
    <span className="inply-coupon-competition-team">
      <span className={`inply-coupon-team-name ${opponentAActive ? 'active' : ''}`}>
        {opponentADescription}
      </span>
      <span className="inply-coupon-score-row inply-coupon-header-set-scores">
        {scoresA.map((s) => <span className="inply-coupon-score">{s}</span>)}
      </span>
    </span>
    { /* ----------------------------------------------------------- */ }

    { /* Team B ---------------------------------------------------- */ }
    <span className="inply-coupon-competition-team">
      <span className={`inply-coupon-team-name ${opponentBActive ? 'active' : ''}`}>
        {opponentBDescription}
      </span>
      <span className="inply-coupon-score-row inply-coupon-header-set-scores">
        {scoresB.map((s) => <span className="inply-coupon-score">{s}</span>)}
      </span>
    </span>
    { /* ----------------------------------------------------------- */ }

    <span className="inply-coupon-competition-more">
      <EventIcons badges={badges} />
      <span className="more">{ t('javascript.more') }</span>
    </span>
  </Link>
);

EventDetailView.propTypes = {
  eventHref: PropTypes.string.isRequired,
  opponentADescription: PropTypes.string.isRequired,
  opponentBDescription: PropTypes.string.isRequired,
  scoresA: PropTypes.instanceOf(Array).isRequired,
  scoresB: PropTypes.instanceOf(Array).isRequired,
  opponentAActive: PropTypes.bool.isRequired,
  opponentBActive: PropTypes.bool.isRequired,
  badges: PropTypes.instanceOf(Array).isRequired,
};

export default EventDetailView;
